import React from 'react';

/**
 * 入力フォーム用の共通コンポーネント
 * @param {Object} props - コンポーネントのプロパティ
 * @param {string} props.id - selectとlabelを関連付けるID
 * @param {string} props.selectTitle - ラベル
 * @param {string} props.value - 入力値
 * @param {function} props.onChange - 入力値が変化したときに呼ばれる関数
 * @param {Array} props.options - セレクト内に表示する選択肢リスト
 * @param {boolean} [props.show=true] - 先頭に「選択してください」を表示するかどうか
 * @param {boolean} [props.required=true] - 必須入力かどうか
 *
 */

const SelectLayout = ({
  id,
  selectTitle,
  value,
  onChange,
  options,
  required=true,
  show=true
}) => {
  return (
    <>
    <div style={{ marginBottom: "10px" }}>
    <label htmlFor={id} style={{ color: "#333", display: "block", marginBottom: "9px" }}>{selectTitle}</label>
    <select
      id={id}
      value={value}
      onChange={onChange}
      required={required}
      style={{
        width: "100%",
        height: "30px",
        margin: "5px 0",
        border: "1px solid #ccc",
        borderRadius: "5px",
        padding: "0 4px"
      }}
      >

        {show && (
          <option value="">選択してください</option>
        )}

        {options.map((op) => (
          <option key={op.id} value={op.value}>
            {op.name}
          </option>
        ))}
    </select>
    </div>
    </>
  );
};

export default SelectLayout;